function Loader() {
  return (
    <div className="flex w-full items-center justify-center py-6" role="status" aria-live="polite">
      <div className="relative h-20 w-20">
        <div className="absolute inset-0 rounded-full border-4 border-sky-100" />
        <div className="absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-sky-600 border-r-cyan-500" />
        <div className="absolute inset-3 animate-pulse rounded-full bg-gradient-to-br from-sky-100 via-cyan-100 to-teal-100" />
      </div>
      <span className="sr-only">Loading</span>
    </div>
  );
}

export default Loader;
